export default {"src":"/_next/static/media/profile-weakness.017e75a6.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};